import { render, staticRenderFns } from "./ListLoveProgrammeSignup.vue?vue&type=template&id=0aacdc72&"
import script from "./ListLoveProgrammeSignup.vue?vue&type=script&lang=js&"
export * from "./ListLoveProgrammeSignup.vue?vue&type=script&lang=js&"
import style0 from "./ListLoveProgrammeSignup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports